module.exports = __webpack_public_path__ + "static/media/b1.7ca98eb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dili/b1.mp3
// module id = MxoG
// module chunks = 0